import { ApprovedEqualDialog } from "@/budget/components/dashboard/ApprovedEqualDialog";
import { useBasisOfDesign } from "@/budget/components/dashboard/useBasisOfDesign";
import { BodBoard } from "@/budget/components/dashboard/BodBoard";

/** Sales › Basis of Design — the same records as the Budgets dashboard section. */
export default function BasisOfDesignPage() {
  const bod = useBasisOfDesign();
  return (
    <div className="page-body" data-testid="sales-bod-page">
      <BodBoard bod={bod} stats extraColumns emptyText="No scope is marked for Basis of Design yet — turn one on in Budgets › Manufacturers." />
      <ApprovedEqualDialog row={bod.emailRow} onClose={bod.closeEmail} />
    </div>
  );
}
